module.exports = __webpack_public_path__ + "static/logo-white-7465fda7cf54d9bd7d5aa1a4e36ae3ed.svg";